import { useMutation } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postUpdateWithdrawalRule = async ({ rule_id, ...updates }) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.UPDATE_WITHDRAWAL_RULE,
    {
      rule_id,
      ...updates,
    }
  );

  return response.data;
};

export const useUpdateWithdrawalRule = () => {
  return useMutation({
    mutationFn: postUpdateWithdrawalRule,
  });
};
